import { ExtendedUser } from './ExtendedUser';
import { User } from './User';
import { ProxyRelatedUser } from './ProxyUser';

export class Profile {
  user: User;
  managers: ExtendedUser[];
  directReports: ExtendedUser[];
  sharedProfileCoaches: ExtendedUser[];
  sharedProfileCoachees: ExtendedUser[];
  proxyCoaches: ProxyRelatedUser[];
  proxyCoachees: ProxyRelatedUser[];
  hasCoachesPermission: boolean;
  hasSharedProfilesPermission: boolean;

  constructor({
    user,
    managers,
    directReports,
    sharedProfileCoaches,
    sharedProfileCoachees,
    proxyCoaches,
    proxyCoachees,
  }: Record<string, any>) {
    this.user = user;
    this.managers = managers !== null ? managers : [];
    this.directReports = directReports !== null ? directReports : [];
    this.sharedProfileCoaches =
      sharedProfileCoaches !== null
        ? [...this.managers, ...sharedProfileCoaches]
        : [...this.managers, ...[]];
    this.sharedProfileCoachees =
      sharedProfileCoachees !== null
        ? [...this.directReports, ...sharedProfileCoachees]
        : [...this.directReports, ...[]];
    this.proxyCoaches = proxyCoaches !== null ? proxyCoaches : [];
    this.proxyCoachees = proxyCoachees !== null ? proxyCoachees : [];
    this.hasCoachesPermission = managers || sharedProfileCoaches;
    this.hasSharedProfilesPermission = directReports || sharedProfileCoachees;
  }
}

export const EmptyProfile: Profile = {
  user: {
    userID: '',
    alias: '',
    owner: '',
    firstName: '',
    lastName: '',
    displayName: '',
    userName: '',
    homeRegion: '',
  },
  managers: [],
  directReports: [],
  sharedProfileCoaches: [],
  sharedProfileCoachees: [],
  proxyCoaches: [],
  proxyCoachees: [],
  hasCoachesPermission: false,
  hasSharedProfilesPermission: false,
};
